export default "__VITE_ASSET__coFzub4x__"